export default "__VITE_ASSET__CJ7JQuvb__"